import { whatIfInnerSelector } from '../../../WhatIfsSelector';

const amountSelector = (state, props) => (
  whatIfInnerSelector(state, props).Amount
);

export default amountSelector;
